module.exports = __webpack_public_path__ + "static/event-41-76b526fc58d054b83ad8b77e84ff5f85.jpg";